import { footerLinks, channels } from '@/mocks/blackliao';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 pt-10 md:pt-14 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="leading-none">
                <span className="block text-lg font-black tracking-tight text-background-50">新黑料网</span>
                <span className="block mt-0.5 text-[10px] text-background-100/70 tracking-widest">围观 · 讨论 · 社区</span>
              </span>
            </a>
            <p className="mt-4 text-xs leading-relaxed text-background-100/75">
              新黑料网首页，汇聚新黑料网论坛热门讨论与热帖排行，查看新黑料网社区实时评论，参与新黑料网围观互动，获取最新网友观点与爆料补充。
            </p>
          </div>
          <div className="md:col-span-1">
            <h4 className="text-sm font-bold text-background-50 mb-3">内容入口</h4>
            <ul className="space-y-2">
              {footerLinks.slice(0, 6).map((l) => (
                <li key={l.label}>
                  <a href="#top" className="text-xs text-background-100/80 hover:text-background-50 transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-1">
            <h4 className="text-sm font-bold text-background-50 mb-3">围观分区</h4>
            <ul className="space-y-2">
              {channels.slice(0, 8).map((c) => (
                <li key={c.key}>
                  <a href="#forum" className="text-xs text-background-100/80 hover:text-background-50 transition-colors">{c.label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-1">
            <h4 className="text-sm font-bold text-background-50 mb-3">新黑料网社区</h4>
            <p className="text-xs text-background-100/80 leading-relaxed">一起理性围观，欢迎提出建设性意见，友善互动每一天。</p>
            <div className="mt-4 flex items-center gap-2">
              {['ri-community-line', 'ri-discuss-line', 'ri-chat-3-line', 'ri-emotion-happy-line'].map((i, idx) => (
                <span key={idx} className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className={`${i} text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-50/10 pt-4">
          <p className="text-[11px] text-background-100/60">© 2026 新黑料网 · 理性吃瓜 文明围观 · 本站内容为网友投稿，仅供参考</p>
          <p className="text-[11px] text-background-100/60 flex items-center gap-1.5">
            <i className="ri-flag-line"></i>投诉 / 申诉 / 澄清 请联系站务
          </p>
        </div>
      </div>
    </footer>
  );
}